import { render, staticRenderFns } from "./partnerSettlementConfiguration.vue?vue&type=template&id=b55b595a"
import script from "./partnerSettlementConfiguration.vue?vue&type=script&lang=js"
export * from "./partnerSettlementConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports